/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ScissorsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M21.5,19.871 C21.5,21.8039966 19.9329966,23.371 18,23.371 C16.0670034,23.371 14.5,21.8039966 14.5,19.871 C14.5,17.9380034 16.0670034,16.371 18,16.371 C19.9329966,16.371 21.5,17.9380034 21.5,19.871 Z" />
      <path d="M14.526,19.443 L5.162,3.534 C4.601,2.582 4.961,1.19 5.912,0.629 L12,10.871" />
      <path d="M9.5,19.871 C9.5,21.8039966 7.93299662,23.371 6,23.371 C4.06700338,23.371 2.5,21.8039966 2.5,19.871 C2.5,17.9380034 4.06700338,16.371 6,16.371 C7.93299662,16.371 9.5,17.9380034 9.5,19.871 Z" />
      <path d="M10.731,12.98 L18.086,0.628 C19.037,1.189 19.398,2.581 18.836,3.533 L9.5,19.371" />
    </g>
  </svg>
);

export default ScissorsIcon;
